import React from "react";
import styles from "./Card.module.scss";

const Card = () => {
  return (
    <div className={styles.container}>
      <form>
        <div className={styles.field}>
          <label>Card number</label>
          <input type="text" placeholder="1234 1234 1234 1234" />
        </div>

        <div className={styles.fieldRow}>
          <div className={styles.field}>
            <label>Expiry</label>
            <input type="text" placeholder="MM / YY" />
          </div>

          <div className={styles.field}>
            <label>CVC</label>
            <input type="text" placeholder="CVC" />
          </div>
        </div>

        <div className={styles.fieldRow}>
          <div className={styles.field}>
            <label>Country</label>
            <select name="country">
              <option value="United States">United States</option>
              <option value="United States">United States</option>
              <option value="United States">United States</option>
              <option value="United States">United States</option>
            </select>
          </div>

          <div className={styles.field}>
            <label>Postal code</label>
            <input type="text" placeholder="90210" />
          </div>
        </div>

        <button>Add Card</button>
      </form>
    </div>
  );
};

export default Card;
